import crud from "./_crud";
 
 const actions = crud('trailer_axle_template', 'el tipo de remolque', 'los tipos de remolques')

export default actions